export const inboundRouteTypes = {
  IVR: 'IVR',
  AUDIO: 'AUDIO',
  CALLBACK: 'CALLBACK',
  QUEUE: 'QUEUE',
  EXTENSION: 'EXTENSION',
  GENERIC_EXTENSION: 'GENERIC_EXTENSION',
  CUSTOMIZED: 'CUSTOMIZED'
};
